import { useLocation } from "@gatsbyjs/reach-router";

const useUrlSearchParams = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  return searchParams;
};

export default useUrlSearchParams;
